"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const loading_1 = __importDefault(require("components/cosmos/loading"));
const modal_1 = require("components/cosmos/v2/modal");
const translate_1 = require("components/translate");
const useAIContentSocket_1 = __importDefault(require("./useAIContentSocket"));
const ContentLoadingData = ({ t, onNextStep, onPreviousStep }) => {
    (0, useAIContentSocket_1.default)({ onNextStep, onPreviousStep });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(modal_1.Modal.Header, { className: "_py-4" }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Body, { className: "_d-flex _flex-column _align-items-center _pt-0 _pb-7", children: [(0, jsx_runtime_1.jsx)(loading_1.default, { "data-test": "loading-hotmart-ai", center: true }), (0, jsx_runtime_1.jsx)("p", { className: "_mb-0", children: t('ai_content_structure.step_02.title') }), (0, jsx_runtime_1.jsx)("p", { className: "_mt-0", children: t('ai_content_structure.step_02.description') })] })] }));
};
exports.default = (0, translate_1.translate)()(ContentLoadingData);
